import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import RoundedLabel from "../../common/label/RoundedLabel/RoundedLabel";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import ExitDoor from "../../svgs/common/ExitDoor";
import { Gear } from "@phosphor-icons/react";
import { MenuCircle } from "../../svgs/common";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

type CourseHeaderProps = {
  title: string;
  label: string;
  isDraft: boolean;
  moduleCount: number;
  onExit: () => void;
  onOpenSettings: () => void;
  onNavigateToStudentView: () => void;
  onOpenGenerateDialog: () => void;
  onTriggerPublishToggle: () => void;
  isSubmitting: boolean;
  showRightSection: boolean;
};

const CourseHeader = ({
  title,
  label,
  isDraft = true,
  moduleCount = 0,
  onExit,
  onOpenSettings,
  onNavigateToStudentView,
  onOpenGenerateDialog,
  onTriggerPublishToggle,
  isSubmitting = false,
  showRightSection = true,
}: CourseHeaderProps) => {
  return (
    <View style={styles.header}>
      <View style={styles.headerLeft}>
        <View style={styles.exitButtonContainer}>
          <CustomButton leftIcon={<ExitDoor />} onPress={onExit} size="s" styleType="transparent" />
        </View>
        <CustomSpacing type="horizontal" size="m" />
        <CustomText text={title} useTranslationText={false} weight="bold" size="m" />
        <CustomSpacing type="horizontal" size="m" />
        {label && (
          <RoundedLabel
            text={label}
            textStyle={["Published", "Graded"].includes(label) ? styles.publishedText : { fontSize: 14 }}
            style={["Published", "Graded"].includes(label) ? styles.publishedLabel : styles.draftLabel}
            padding={[8, 6]}
            isRounded={true}
          />
        )}
      </View>

      {showRightSection && (
        <View style={styles.headerRight}>
          {moduleCount === 0 && (
            <>
              <CustomButton
                size="s"
                text="Generate Course"
                styleType="primaryLight"
                textStyle={{ fontSize: 14, fontWeight: 700 }}
                onPress={onOpenGenerateDialog}
                disabled={isSubmitting}
                style={isSubmitting ? { backgroundColor: "#ccc" } : {}}
              />
              <CustomSpacing type="horizontal" size="m" />
            </>
          )}
          <CustomButton
            size="s"
            text="Student View"
            styleType="primaryLight"
            textStyle={{ fontSize: 14, fontWeight: 700 }}
            onPress={onNavigateToStudentView}
          />
          <CustomSpacing type="horizontal" size="m" />
          <CustomButton
            size="s"
            text={isDraft ? "Publish" : "Unpublish"}
            styleType="primary"
            textStyle={{ fontSize: 14, fontWeight: 700 }}
            onPress={onTriggerPublishToggle}
            disabled={isSubmitting}
            style={isSubmitting ? { backgroundColor: "#ccc" } : {}}
          />
          <CustomSpacing type="horizontal" size="m" />
          <CustomButton
            size="s"
            text=""
            leftIcon={<Gear size={24} color="#3E68FE" />}
            styleType="primaryLight"
            textStyle={{ fontSize: 14, fontWeight: 700 }}
            onPress={onOpenSettings}
            disabled={isSubmitting}
            style={isSubmitting ? { backgroundColor: "#ccc" } : {}}
          />
        </View>
      )}
    </View>
  );
};

export default CourseHeader;

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomColor: "#D0D5DD",
    borderBottomWidth: 1,
    height: 62,
  },
  headerLeft: {
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  headerRight: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    paddingRight: 20,
  },
  exitButtonContainer: {
    borderRightColor: "#D0D5DD",
    borderRightWidth: 1,
    paddingHorizontal: 10,
  },
  draftLabel: {
    backgroundColor: "#EAECF0",
    borderRadius: 360,
  },
  publishedLabel: {
    backgroundColor: "#66C61C",
    borderRadius: 360,
  },
  publishedText: {
    color: "#FFFFFF",
    fontSize: 14,
  },
});
